/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

/**
 * getTunnelConnectionCommand.js --
 *
 * get tunnel connection.
 *
 */

import { globalArray } from "../jscdkClient";
import GetTunnelConnectionHandler from "../controllers/getTunnelConnectionHandler";

export default function GetTunnelConnectionCommand() {}

/**
 * Invoked by JSCDKController
 *
 * @param getTunnelConnAction[in]
 *        - its property 'method' has the value 'GetTunnelConnection'
 */
GetTunnelConnectionCommand.prototype.execute = function (getTunnelConnAction) {
   let getTunnelConnObject,
      handlerList,
      router = globalArray["router"];

   getTunnelConnObject = globalArray["get-tunnel-connection"];
   if (!getTunnelConnObject) {
      getTunnelConnObject = new GetTunnelConnectionHandler();
      globalArray[getTunnelConnObject.messageName] = getTunnelConnObject;
      globalArray[getTunnelConnObject.responseTag] = getTunnelConnObject;
   } else {
      getTunnelConnObject.resetData();
   }

   getTunnelConnObject.setRequestXML(getTunnelConnAction.bypassTunnel);
   handlerList = getTunnelConnObject.composeHandlerList();
   router.postMessage(handlerList);
};
